import { Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NotificationService } from '@core/services/notification.service';
import { NzModalRef } from 'ng-zorro-antd/modal';

@Component({
  selector: 'quantidade-caracteres-sinopse-modal',
  templateUrl: './qt-caracteres-sinopse-modal.component.html',
  styleUrls: ['./qt-caracteres-sinopse-modal.component.scss']
})
export class QtCaracteresSinopseModalComponent implements OnInit {

  @Input() regerar: boolean = false;
  @Input() itensSelecionados: any[] = [];

  qtCaracteresSinopseForm!: FormGroup;

  constructor(
    private fb: FormBuilder,
    private modal: NzModalRef,
    private notificationService: NotificationService,
  ) { }

  ngOnInit() {
    this.construirForm();
  }

  construirForm() {
    this.qtCaracteresSinopseForm = this.fb.group({
      qtd: ['']
    })
  }
  
  submit() {
    if (this.qtCaracteresSinopseForm.valid) {
      const objEnvio = { 
        ...this.qtCaracteresSinopseForm.getRawValue(),
        itensSelecionados: this.itensSelecionados,
      };
      this.voltar(objEnvio);
    } else {
      this.notificationService.warn('Erro!', 'Valor inválido');

    }
  }

  voltar(dadosEnvio?: any): void {
    this.modal.destroy(dadosEnvio);
  }
}
